export default "__VITE_ASSET__BwfUJZkj__"